<template>
  <div>
    <div class="head-bg-wrapper">
      <div>
        <img :src="headProp.contentImageUrl" alt="广州幂动科技" />
      </div>
      <div class="title-content" style="margin-top: 60px">
        {{ headProp.textLine1 }}
      </div>
      <div class="title-content">{{ headProp.textLine2 }}</div>
      <div class="sub-title">{{ headProp.subText }}</div>
    </div>

    <div class="content-wrapper" style="width: 100%; padding: 20px 0">
      <y-head-content v-bind="content1" />

      <!-- <div class="content-wrapper table-wrapper">
        <div class="table-title">热门职位</div>
        <el-table
          :data="tableData"
          style="width: 100%"
          :show-header="false"
          row-class-name="table-row">
          <el-table-column
            prop="position"
            label="职位">
          </el-table-column>
          <el-table-column
            prop="company"
            label="公司">
          </el-table-column>
          <el-table-column
            prop="salary"
            label="薪资">
          </el-table-column>
          <el-table-column
            label="详情"
            width="120">
            <template slot-scope="scope">
              <a class="table-link" target="_self" :href="getAppUrl(scope.row.id)">
                详细信息<img src="static/images/turn_in_icon.png">
              </a>
            </template>
          </el-table-column>
        </el-table>
      </div> -->

      <y-text-img v-bind="content2" />

      <div class="content-wrapper">
        <el-row>
          <el-col :span="24" class="y-title">
            <span class="title-content">{{ $t("home.cooperator") }}</span>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col
            v-for="item3 in content3"
            :key="item3.id"
            :sx="24"
            :sm="24"
            :lg="20"
          >
            <img style="width: 100%" :src="item3.image" alt="广州幂动科技" />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import YHeadContent from "@/components/y-head-content/y-head-content";
import YTextImg from "@/components/y-text-img/y-text-img";

var content3 = [
  {
    id: 1,
    image:
      "http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/home/content-3-1.png",
  },
];

export default {
  components: {
    YHeadContent,
    YTextImg,
  },
  data() {
    return {
      headProp: {
        contentImageUrl:
          "https://sucai003.oss-cn-qingdao.aliyuncs.com/midong/home/logo-190x150.png",
        textLine1: this.$t("home.head.textLine1"),
        textLine2: this.$t("home.head.textLine2"),
        subText: this.$t("home.head.subText"),
      },
      content1: {
        yTitle: this.$t("home.content1.yTitle"),
        contentItems: [
          {
            id: "1",
            image:
              "http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/home/content-1-1.png",
            text: this.$t("home.content1.contentItem1"),
          },
          {
            id: "2",
            image:
              "http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/home/content-1-2.png",
            text: this.$t("home.content1.contentItem2"),
          },
          {
            id: "3",
            image:
              "http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/home/content-1-3.png",
            text: this.$t("home.content1.contentItem3"),
          },
          {
            id: "4",
            image:
              "http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/home/content-1-4.png",
            text: this.$t("home.content1.contentItem4"),
          },
        ],
      },
      content2: {
        contentItems: [
          // {
          //   id: 1,
          //   mainContent: this.$t('home.content2.contentItem1.mainContent'),
          //   subContent: this.$t('home.content2.contentItem1.subContent'),
          //   image: 'http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/home/content-2-1.png'
          // },
          {
            id: 2,
            mainContent: this.$t("home.content2.contentItem2.mainContent"),
            subContent: this.$t("home.content2.contentItem2.subContent"),
            image:
              "http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/home/content-2-2.png",
          },
          // {
          //   id: 3,
          //   mainContent: this.$t('home.content2.contentItem3.mainContent'),
          //   subContent: this.$t('home.content2.contentItem3.subContent'),
          //   image: 'http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/home/content-2-3.png'
          // },
        ],
      },
      content3,
      tableData: [
        {
          id: "1",
          position: "广告平台运营",
          company: "EK传媒",
          salary: "4k - 8k",
        },
        {
          id: "2",
          position: "后端广告算法工程师",
          company: "EK传媒",
          salary: "10k - 20k",
        },
        {
          id: "3",
          position: "商务",
          company: "EK传媒",
          salary: "10k - 20k",
        },
        {
          id: "4",
          position: "app海外产品运营",
          company: "北京柏木科技",
          salary: "20k",
        },
        {
          id: "5",
          position: "商务经理-预装",
          company: "北京柏木科技",
          salary: "25k",
        },
        {
          id: "6",
          position: "iOS高级开发工程师",
          company: "纤寻科技",
          salary: "8k - 15k",
        },
        {
          id: "7",
          position: "Android高级开发工程师",
          company: "纤寻科技",
          salary: "8k - 15k",
        },
        {
          id: "8",
          position: "前端开发工程师",
          company: "S.K.Y",
          salary: "8k - 16k",
        },
        {
          id: "9",
          position: "后端开发工程师",
          company: "S.K.Y",
          salary: "15k - 25k",
        },
        {
          id: "10",
          position: "行政兼前台",
          company: "S.K.Y",
          salary: "4k - 6k",
        },
        {
          id: "11",
          position: "新媒体运营",
          company: "纤寻科技",
          salary: "5k - 12k",
        },
        {
          id: "12",
          position: "系统测试工程师",
          company: "EK传媒",
          salary: "6k - 10k",
        },
      ],
    };
  },
  mounted() {
  },
  methods: {
    getAppUrl(id) {
      return `${window.location.origin}/recruit?recruitid=${id}`;
    },
  },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import "../../commons/style/index.scss";

.head-bg-wrapper {
  background-image: url("http://sucai003.oss-cn-qingdao.aliyuncs.com/midong/home/bg.png");
  img {
    @media (max-width: 640px) {
      width: 100px;
    }
  }
  .title-content {
    font-size: 48px;
    @media (max-width: 640px) {
      padding-top: 3rem;
      font-size: 1.875rem;
    }
  }
}

.content-wrapper {
  padding: 20px;
  margin: 0px auto;
  @media (min-width: 768px) {
    width: 100%;
  }
  @media (min-width: 1200px) {
    width: 1200px;
  }
}

.table-wrapper {
  padding: 60px 20px;
  margin: 0px auto;
  @media (min-width: 768px) {
    width: 80%;
  }
  @media (min-width: 1200px) {
    width: 1000px;
  }
  .table-link {
    text-decoration: none;
    color: #6292ad;
    img {
      height: 10px;
      vertical-align: middle;
    }
  }
}
</style>

<style lang="scss" rel="stylesheet/scss">
.table-title {
  background-color: #6292ad;
  color: #ffffff;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.table-row {
  background-color: #f7fbfa !important;
  color: #6292ad !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue